exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.butn_group[data-v-7e99f4ec] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.adminlist_btns[data-v-7e99f4ec] {\n  width: 100%;\n}\n.justify-content-end[data-v-7e99f4ec] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: end;\n}\n", ""]);

// exports
